import { gql } from '@/store/helpers/axios.js'

export default {
  async PROJEKTSTATUS_SIGNATION_UPDATE ({ commit }, gesuchId) {
    const query = `mutation projektstatusSignationUpdate ($input: ProjektstatusUpdateInput) {
      projektstatusSignationUpdate(input: $input) {
        gesuchId
        projektstatusId
      }
    }`

    const variables = {
      input: {
        gesuchId: Number(gesuchId)
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },

  async PROJEKTSTATUS_SIGNATION_CREATE ({ commit }, formData) {
    const {
      gesuchId,
      gesuchKey
    } = formData

    const query = `mutation projektstatusSignationCreate ($input: ProjektstatusCreateInput) {
      projektstatusSignationCreate(input: $input) {
        gesuchId
        projektstatusId
      }
    }`

    const variables = {
      input: {
        gesuchId: Number(gesuchId),
        tStatusId: 17,
        gesuchKey
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },

  async GESUCH_PROJEKTABSCHLUSS_UPDATE ({ commit }, formData) {
    const {
      gesuchId,
      projektabschlussAuswahl,
      projektabschlussText,
      gesuchKey
    } = formData

    const query = `mutation handInProjektabschluss ($input: GesuchUpdateInput) {
      handInProjektabschluss(input: $input) {
        ok
      }
    }`

    const variables = {
      input: {
        gesuchId: Number(gesuchId),
        projektabschlussAuswahl,
        projektabschlussText,
        gesuchKey
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },

  async GET_KONTO_BY_GESUCHID ({ commit }, applicationId) {
    const query = `query konto($gesuchId: Int!) {
      konto(gesuchId: $gesuchId) {
        kontoId
        bankname
        bankPlzOrt
        esrReferenznummer
        gesuchId
        iban
        inhaberHausNr
        inhaberLandId
        inhaberName
        inhaberOrt
        inhaberPlz
        inhaberStrasse
        kontoartId
        version
      }
    }`

    const variables = {
      gesuchId: Number(applicationId)
    }

    const { data } = await gql({ query, variables })

    return data
  },

  async KONTO_UPDATE ({ commit }, formData) {
    const {
        kontoId,
        bankname,
        bankPlzOrt,
        esrReferenznummer,
        gesuchId,
        iban,
        inhaberHausNr,
        inhaberLandId,
        inhaberName,
        inhaberOrt,
        inhaberPlz,
        inhaberStrasse,
        kontoartId
    } = formData

    const query = `mutation kontoUpdate ($input: KontenUpdateInput) {
      kontoUpdate(input: $input) {
        ok
      }
    }`

    const variables = {
      input: {
        kontoId: Number(kontoId),
        gesuchId: Number(gesuchId),
        iban,
        inhaberHausNr,
        inhaberLandId,
        inhaberName,
        inhaberOrt,
        inhaberPlz,
        inhaberStrasse,
        kontoartId,
        bankname,
        bankPlzOrt,
        esrReferenznummer
      }
    }

    const { data } = await gql({ query, variables })

    return data
  }
}
